module.exports = __webpack_public_path__ + "img/20190611_113036_013.e14bd6fd.jpg";